import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Loader from '../../../../loader/Loader'
import { get_Page_Seo } from '../../../../api/global/Global'
import Footer from '../../../common/footer/Footer'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';

const All_Shop_By_Collection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [pageSeo, set_Page_Seo] = useState({})
    const { all_Collections } = location?.state || {};
    const [is_loading, set_Is_Loading] = useState(false);
    const [sub_category_data, set_Sub_Category_Data] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    const get_category_list_result_slug = localStorage.getItem("category_list_result_slug")
    // Ensure sub_category_data is always a valid array
    const validSubCategoryData = Array.isArray(all_Collections) ? all_Collections : [];

    // Calculate total pages safely
    const totalPages = Math.ceil(validSubCategoryData?.length / productsPerPage);

    // Calculate products for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentSubCategory = validSubCategoryData?.slice(startIndex, startIndex + productsPerPage);

    // Handle pagination (next, prev, page number click)
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
  
    // <------------seo data fetch -------------->
    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "All Collections")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }

        Get_Page_Seo()
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <div>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}shop-by-collection`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}shop-by-collection`} />

            </Helmet>
            {/* <----- Header section's ---------> */}
            <Header />
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        {/* <------ Category main banner section's --------> */}
                        <section className='banner-section'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-[300px]' />


                            </div>
                        </section>
                        {/* <div className="gi-breadcrumb bg-center bg-no-repeat bg-cover">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] relative">
                                <div className="flex flex-wrap w-full">
                                    <div className="w-full px-[12px]">
                                        <div className="flex flex-wrap m-0 py-[35px]">
                                            <div className="min-[768px]:w-[50%] w-full">

                                                <ul className="gi-breadcrumb-list mt-5">
                                                    <li
                                                        className="gi-breadcrumb-item inline-block text-[13px] font-medium tracking-[0.02rem] leading-[1.2] uppercase">
                                                        <Link to="/" className="relative"> Home</Link>
                                                    </li>
                                                    <li
                                                        className="gi-breadcrumb-item inline-block text-[13px] font-medium tracking-[0.02rem] leading-[1.2] uppercase">
                                                        <span className="relative">/ all collections</span>
                                                    </li>
                                                   
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <section className="gi-category py-[40px] max-[767px]:py-[0px]">
                            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="flex flex-wrap w-full">
                                    <div className="gi-shop-rightside min-[992px]:w-[100%] max-[767px]:pt-[30px] min-[992px]:w-[100%] min-[768px]:w-full w-full px-[12px]">
                                        <div className="gi-pro-list-top md:flex items-center justify-between text-[14px] mb-[15px]">
                                            <div className="w-full gi-grid-list text-left">
                                                <h1 className="text-lg font-semibold text-gray-950">List of All Collections</h1>
                                                <div className="border-b-2 border-b-black  w-[140px] mb-3"></div>
                                            </div>
                                        </div>
                                        <div className="shop-pro-content">
                                            <div className="shop-pro-inner">
                                                <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-5">
                                                    {all_Collections?.map((collection_result) => (
                                                        <div key={collection_result?.id}
                                                            // onClick={() =>
                                                            //     navigate(`/product/${product_list_result?.slug}`, {
                                                            //         state: {
                                                            //             product_list_result,
                                                            //             category_id: product_list_result?.cat_id,
                                                            //             subcategory_id: product_list_result?.sub_id,
                                                            //         },
                                                            //     })
                                                            // }
                                                            className="w-full">
                                                            <div className="gi-product-content h-full">
                                                                <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out shadow-custome">
                                                                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                                                                        <div className="gi-pro-image pt-4">
                                                                            <Link to="#" className="image productimg7 relative block pointer-events-none">
                                                                                <img className="main-image min-w-[170px] h-[170px] rounded-full border border-gray-100 transition-all duration-[0.3s] ease delay-[0s]"
                                                                                    src={`${IMG_BASE_URL}${collection_result?.image}`} alt={collection_result?.image_alt} />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="gi-pro-content h-full p-[30px] pt-[0] relative z-[10] flex flex-col text-center">
                                                                        <h4 className="gi-pro-stitle mt-4 text-gray-800 uppercase text-[14px] font-semibold leading-[1.2] whitespace-nowrap overflow-hidden">
                                                                            {collection_result?.name}
                                                                        </h4>


                                                                        <div className="flex flex-col mt-2 justify-center gap-4 items-center">
                                                                            <button type="button" onClick={() => {

                                                                                navigate(`/collection/${collection_result?.slug}`)

                                                                            }} className="text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300">View More</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, sub_category_data?.length)} of {sub_category_data?.length} item(s)</span>
                                                <ul className="gi-pro-pagination-inner flex">
                                                    <li>
                                                        <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                            Prev
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPages).keys()].map((page) => (
                                                        <li key={page} className="inline-block float-left mr-[5px]">
                                                            <button
                                                                onClick={() => handlePageChange(page + 1)}
                                                                className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                                                                    text-[16px] justify-center items-center rounded-[5px]
                                                                     ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                            >
                                                                {page + 1}
                                                            </button>
                                                        </li>
                                                    ))}

                                                    <li>
                                                        <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )
            }
            <Footer />
        </div>
    )
}

export default All_Shop_By_Collection